import React, { useState, useEffect } from 'react';
import './Hero.css';

const SLIDES = [
  {
    title: 'Kalite Mühendisliğinin Ulusal Temsil Platformu',
    subtitle: 'TKMB – Türkiye Kalite Mühendisleri Birliği, kalite mühendisliği alanında mesleki koordinasyonu güçlendirmek ve kalite kültürünü kurumsal düzeyde yaygınlaştırmak amacıyla faaliyet gösteren ulusal bir mesleki platformdur.',
    gradient: 'linear-gradient(135deg, #62c470 0%, #52b85f 50%, #72d080 100%)',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80',
  },
  {
    title: 'Mesleki Standartlar ve Yetkinlik',
    subtitle: 'Ortak mesleki çerçeve, yetkinlik tanımları ve rehber dokümanlarla sektörde tutarlılık ve tanınırlık sağlıyoruz.',
    gradient: 'linear-gradient(135deg, #4a9e55 0%, #62c470 50%, #52b85f 100%)',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a739f?w=1920&q=80',
  },
  {
    title: 'Sanayi ile İş Birliği',
    subtitle: 'Kalite yönetim sistemleri, eğitim, uzman yönlendirme ve kurumsal gelişim çalışmaları ile kalite kültürünü yaygınlaştırıyoruz.',
    gradient: 'linear-gradient(135deg, #52b85f 0%, #72d080 50%, #8ee099 100%)',
    image: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=1920&q=80',
  },
  {
    title: 'Üyelik ve Sicil Sistemi',
    subtitle: 'Meslek mensupları için sicil kaydı, yetkinlik doğrulama ve teknik ağ imkânları sunuyoruz.',
    gradient: 'linear-gradient(135deg, #4a9e55 0%, #52b85f 50%, #62c470 100%)',
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1920&q=80',
  },
  {
    title: 'TKMB ile Tanışın',
    subtitle: 'Vizyon ve misyonumuz doğrultusunda kalite odaklı yönetim anlayışını yaygınlaştırıyoruz.',
    gradient: 'linear-gradient(135deg, #62c470 0%, #52b85f 100%)',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1920&q=80',
  },
];

const Hero = ({ onNavigate }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index) => setActiveIndex(index);
  const prev = () => setActiveIndex((prev) => (prev - 1 + SLIDES.length) % SLIDES.length);
  const next = () => setActiveIndex((prev) => (prev + 1) % SLIDES.length);

  const slide = SLIDES[activeIndex];

  return (
    <section id="hero" className="hero hero-tkmb hero-with-slider">
      <div className="hero-slider">
        {SLIDES.map((s, index) => (
          <div
            key={index}
            className={`hero-slide ${index === activeIndex ? 'active' : ''}`}
            style={{
              background: s.image
                ? `linear-gradient(135deg, rgba(98, 196, 112, 0.82) 0%, rgba(82, 184, 95, 0.88) 50%, rgba(0, 0, 0, 0.35) 100%), url(${s.image})`
                : s.gradient,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
            aria-hidden={index !== activeIndex}
          />
        ))}
      </div>
      <div className="hero-pattern" aria-hidden="true" />
      <div className="hero-overlay hero-overlay-tkmb" aria-hidden="true" />
      <button type="button" className="hero-arrow hero-arrow-left" onClick={prev} aria-label="Önceki slayt">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <button type="button" className="hero-arrow hero-arrow-right" onClick={next} aria-label="Sonraki slayt">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
      <div className="hero-dots">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`hero-dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => goTo(index)}
            aria-label={`Slayt ${index + 1}`}
          />
        ))}
      </div>
      <div className="hero-content">
        <span className="hero-badge">TKMB</span>
        <div key={activeIndex} className="hero-text">
          <h1 className="hero-title">{slide.title}</h1>
          <p className="hero-subtitle">{slide.subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
